// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b19ea4{padding:var(--spacer) var(--spacer) 0 !important}._98d33e{text-align:center;font-weight:600;color:var(--secondary)}._98d33e small{font-weight:500;opacity:.875;display:block}.a36c71{margin:1em 1em 0;padding-right:.25em}", ""]);
// Exports
exports.locals = {
	"timelog": "b19ea4",
	"header": "_98d33e",
	"scrollable": "a36c71"
};
module.exports = exports;
